<div class="content-div">
    @if (showLoaderOverlay) {
      <app-loader-overlay></app-loader-overlay>
    }
    <div class="heading-div">
        <div class="heading-content">
            <h1 class="heading-title">Find a Job or Internship</h1>
            <p class="sub-title">
                Opportunities for you, based on your skills and background.
                Choose a posting to learn more.
            </p>
        </div>

    </div>

    <app-job-filter 
    (filterFormEmitter)="filterJobList($event)"
    (filterTabEmitter)="onFilterTabToggle($event)"
    (sortEmitter)="sortJobList($event)"></app-job-filter>

    @if(!isCareerGoalSet) {
    <div class="alert alert-info" role="note">
        <p>Want to see more relevant jobs?</p>
        <div type="button" class="alert-btn" (click)="navigateToCareerGoal()">
            Set a career goal
            <img class="arrow-right" src="/assets/images/arrow-right.png" alt="arrow-right" />
        </div>
    </div>
    } @else if (userJobFilters.is_related_to_career_goal) {
        <div class="career-goal-notification">
            <p>Job postings related to
                <a [routerLink]="`/career-details/${userCareerOnetCode}`" target="_blank">
                    your career goal
                </a>
            </p>
        </div>
    }

    <app-job-item [isFilterTabOpen]="isFilterTabOpen" (jobClickEmitter)="onClickJobItem($event)"></app-job-item>

</div>